/**
 * Build avatar initials from a person's name, used as the fallback when no
 * profile photo has been uploaded.
 *   "Vikas Poojary"   -> "VP"   (first + last name)
 *   "Vikas J Poojary" -> "VP"   (first + last, middle skipped)
 *   "Manjunath"       -> "M"    (single name -> first letter)
 *   ""/null           -> "E"    (generic "Employee" fallback)
 *
 * @param {string} name
 * @returns {string} 1-2 uppercase letters
 */
export const getInitials = (name) => {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return 'E';
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
};

export default getInitials;
